import React from 'react';
import Locale from 'localization/Localization';
import moment from 'moment';
import { AppServices } from 'services/AppServices';
import { Spinner } from 'components/common/Spinner';
import { ResultMessage, ResultStyle, ResultMessageView } from '../common/ResultMessageView';
import { PTProgram } from 'models/PTProgram';
import Clipboard from 'react-clipboard.js';

class BlockInfo {
	public guid: string = '';
	public name: string = '';
	public beginDays: number = 0;
	public durationDays: number = 0;
	//public week: number = 0;

	static calculateBlocks(sets: PTProgram[]): Array<BlockInfo> {

		let blocks: Array<BlockInfo> = [];

		const sorted = sets.sort((a: PTProgram, b: PTProgram) => {
			return a.validFromUtc.unix() - b.validFromUtc.unix();
		});

		if (sorted.length > 0) {
			const setBegin = sorted[0].validFromUtc.startOf('day');

			for (let prog of sorted) {
				const start = prog.validFromUtc.startOf('day');
				const end = prog.validToUtc.endOf('day');

				const duration = moment.duration(end.diff(start));
				const offset = moment.duration(start.diff(setBegin));

				let block = new BlockInfo();
				block.guid = prog.guid;
				block.name = prog.name;
				block.beginDays = Math.floor(offset.asDays()) + 1;
				block.durationDays = Math.floor(duration.asDays());
				//block.week = Math.floor(offset.asDays() / 7);
				blocks.push(block);
			}
		}

		return blocks;
	}
}

interface ContentSetsProps {
	contentId?: string;
	ptId?: string;
}

interface ContentSetsState {
	contentSets?: PTProgram[];
	isLoading: boolean;
	clipboardMessage?: ResultMessage;
}

export class ContentSets extends React.Component<ContentSetsProps, ContentSetsState>
{
	constructor(props: ContentSetsProps) {
		super(props);

		this.state = {
			contentSets: [],
			isLoading: true
		};

		this.getSets = this.getSets.bind(this);
		this.getContentDuration = this.getContentDuration.bind(this);
		this.onClickContentId = this.onClickContentId.bind(this);
		this.onClickContentBlock = this.onClickContentBlock.bind(this);
	}

	public componentDidMount() {
		this.getSets();
	}

	private async getSets() {

		this.setState({
			contentSets: undefined,
			isLoading: true
		})

		if (this.props.contentId !== undefined && this.props.contentId !== '') {
			AppServices.contentService.getContentSets(this.props.contentId)
				.then((sets: PTProgram[]) => {
					console.log(sets);

					this.setState({
						contentSets: sets,
						isLoading: false
					});
				})
				.catch(() => {
					this.setState({
						contentSets: undefined,
						isLoading: false
					});
				});
		}
	}

	private getContentDuration(): number {
		let days: number = 0;

		if (this.state.contentSets !== undefined && this.state.contentSets.length > 0) {

			const beginDates = this.state.contentSets.map((p: PTProgram, i: number) => {
				return p.validFromUtc.startOf('day');
			});

			const endDates = this.state.contentSets.map((p: PTProgram, i: number) => {
				return p.validToUtc.endOf('day');
			})

			const begin = moment.min(beginDates);
			const end = moment.max(endDates);
			const duration = moment.duration(end.diff(begin));
			days = Math.floor(duration.asDays());
		}

		return days;
	}

	private onClickContentId() {
		setTimeout(() => {
			if (this.props.contentId !== undefined && this.props.ptId !== undefined) {
				const link = this.props.ptId !== ''
					? ('https://' + this.props.ptId + '.physiotoolsonline.com') : '#';
				window.open(link);
			}
		}, 1000);

		this.setState({
			clipboardMessage: new ResultMessage(Locale.get('contentCodeDetails_copiedToClipboard'), ResultStyle.Info)
		});
	}

	private onClickContentBlock(guid: string) {
		if (guid !== '') {
			const link =
				"https://gateway.physiotoolsonline.com/PT_IntegrationService/api/PTSet/GetSet?"
				+ "PrintDataId=" + guid;
			window.open(link);
		}
		else {
			alert(Locale.get('contentSets_alertNoGuid'));
		}
	}

	public render() {

		const duration = this.getContentDuration();

		const generateBlocks = (sets: PTProgram[]) => {
			return BlockInfo.calculateBlocks(sets).map(
				(x: BlockInfo, i: number) => {
					return (
						<div className='content-block' key={x.guid}
							style={{
								gridColumnStart: x.beginDays,
								gridColumnEnd: 'span ' + x.durationDays
							}}
							onClick={() => this.onClickContentBlock(x.guid)}>
							<h3>{x.name}</h3>
							<div className='content-block-desc'>
								{
									x.beginDays > 0 &&
									<p>{Locale.format('contentSets_beginDay', x.beginDays.toString())}</p>
								}
								<p>{Locale.format('contentSets_durationDays', x.durationDays.toString())}</p>
							</div>
						</div>
					);
				})
		}

		return (this.state.contentSets !== undefined &&
			<div>
				<h2>{Locale.get('contentSets_title')}</h2>
				{
					this.state.isLoading &&
					<Spinner />}
				{
					(this.state.isLoading === false && this.state.contentSets === undefined) &&
					<p>{Locale.get('contentSets_errorLoadFailed')}</p>
				}
				{
					(this.state.isLoading === false && this.state.contentSets !== undefined) &&
						duration === 0
						? <p>{Locale.get('contentSets_noContent')}</p>
						: <div>
							{
								this.props.contentId !== undefined &&
								<React.Fragment>
									<Clipboard component='a' className='content-link'
										onClick={this.onClickContentId}
										data-clipboard-text={this.props.contentId}>
										{Locale.format('contentSets_guidLinkFormat', this.props.contentId)}
									</Clipboard>
									<ResultMessageView message={this.state.clipboardMessage} />
								</React.Fragment>
							}
							<p>
								{
									Locale.format(
										'contentSets_details',
										this.state.contentSets.length.toString(),
										duration.toString())
								}
							</p>
						<div className='content-block-grid'>
								{generateBlocks(this.state.contentSets)}
							</div>
						</div>
				}
			</div>
		);
	}
}